/**
 * payment webview의 라우트 경로 상수.
 *
 * 도메인: payment-onl-webview.uglee.io
 *
 * 네임스페이스 단위 단일 라우트 전략 — 단발 결제 흐름은 InAppWebView 환경에서
 * 페이지 이동 비용을 줄이기 위해 페이지 1개 + step 분기(useFunnel) 패턴을 사용.
 */
export const ROUTES = {
  ROOT: '/',
  DEBUG: '/debug',
  SEALED_VINYL: '/sealed-vinyl',
  /**
   * 토스/네이버 successUrl 중계 라우트. PG에서 redirect되면 즉시
   * POST /product-payments/process로 결제 데이터를 저장하고
   * `/sealed-vinyl/result?key=UUID`로 navigate(replace).
   */
  SEALED_VINYL_PROCESS: '/sealed-vinyl/process',
  /** PG 결제 후 결과 화면 — `?paymentId=` (카드·카카오) 또는 `?key=` (토스·네이버) */
  SEALED_VINYL_RESULT: '/sealed-vinyl/result',
  /** 카드 등록 폼 — PaymentStep "결제 카드 추가"에서 진입 */
  SEALED_VINYL_CARD_REGISTER: '/sealed-vinyl/card-register',
  /**
   * 카카오 카드 등록 successURL 복귀 중계 라우트.
   * 백엔드가 등록 승인 후 `?paymentMethodId=`(성공) / `?status=cancel|fail` 로 302 redirect.
   * resume 저장 후 /sealed-vinyl 로 복귀해 PaymentStep·수량·새 카드 복원.
   */
  SEALED_VINYL_CARD_REGISTER_CALLBACK: '/sealed-vinyl/card-register-callback',
} as const

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES]
